import { SecurityScanOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Layout from '@/components/layout';
import SecondLayout from '@/components/layout/second-layout';
import AccessDeny from '@/pages/access-deny';
import Login from '@/pages/login';
import NotFound from '@/pages/not-found';
import SubApp from '@/pages/sub-app';
import JoydataRedirect from '@/pages/joydata-redirect';
import { CustomRouteObject } from '@/types/type';
import dashboardRoutes from '@/pages/dashboard/routes-dashboard';
import managementRoutes from '@/pages/management/routes';
import { RoutePath } from './enum';
const UserInfo = lazy(() => import('@/pages/user-info'));
const MyPower = lazy(() => import('@/pages/my-power'));
const Guide = lazy(() => import('@/pages/guide'));
const ResetPassword = lazy(() => import('@/pages/reset-password'));
const routes: CustomRouteObject[] = [
  {
    path: '/login',
    hidden: true,
    exact: true,
    element: <Login />,
  },
  {
    path: '/reset-password',
    hidden: true,
    exact: true,
    element: <ResetPassword />,
  },
  {
    path: '/',
    hidden: true,
    element: <Navigate to={RoutePath.GUIDE} />,
  },
  {
    path: '/',
    name: '管理中心',
    icon: <SecurityScanOutlined />,
    // hidden: true,
    element: <Layout />,
    children: [
      {
        path: '/user-info',
        name: t('User info.User info'),
        checkAuth: false,
        hidden: true,
        element: <UserInfo />,
      },
      {
        path: '/my-power',
        name: '我的权限',
        hidden: true,
        // checkAuth: true,
        element: <MyPower />,
      },
      {
        path: '/guide',
        name: '导航中心',
        checkAuth: false,
        element: <Guide />,
      },
      ...dashboardRoutes,
      ...managementRoutes,
    ],
  },
  {
    path: '/my-power',
    name: '我的权限',
    hidden: true,
    // checkAuth: true,
    element: <MyPower />,
  },
  {
    // joydata 子项目已从主站移除，访问此路由时重定向到对应环境的独立域名
    path: '/app/joydata',
    hidden: true,
    element: <JoydataRedirect />,
  },
  {
    path: '/app/:appKey',
    hidden: true,
    element: <SubApp />,
  },
  {
    path: '/404',
    hidden: true,
    element: <NotFound />,
  },
  {
    path: '*',
    hidden: true,
    element: <Navigate to="/404" />,
  },
];

export default routes;
